import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AbilityService } from 'ability';
import { RoutingPath } from 'mbs-ui-shared@constants';
import { PermissionsEnum } from 'mbs-ui-shared@models';

// The global Notifications page only has content when at least one of its sections is available:
// Backup/Restore cards + end-user toggles (Backup or M365), the RMM card, or the Deep Instinct card.
export const hasNotificationsContent = (ability: AbilityService): boolean =>
  ability.can('read', PermissionsEnum.Backup) ||
  ability.can('read', PermissionsEnum.GoogleApps) ||
  (ability.can('read', PermissionsEnum.RmmPerAdminLicenseExists) && ability.can('read', PermissionsEnum.Rmm)) ||
  (ability.can('read', PermissionsEnum.ShowDeepInstinct) && ability.can('read', PermissionsEnum.ShowDeepInstinctProvider));

export const notificationsContentGuard: CanActivateFn = () => {
  const ability = inject(AbilityService);
  const router = inject(Router);

  if (hasNotificationsContent(ability)) return true;

  return router.createUrlTree([ability.can('read', 'Provider') ? RoutingPath.ApDefaultAspx : RoutingPath.ApSettings]);
};
